import axios from "axios"

const BASEURL = process.env.REACT_APP_BASEURL;

export const AuthLogin = async (Data) => {
    const response = await axios.post(
        `${BASEURL}/auth/login`, Data
    )
    return response
}

export const SendEmail = async (Data) => {
    const response = await axios.post(`${BASEURL}/email/sendemail`, Data)
    return response.data
}

export const PostOrders = async (Data) => {
    const response = await axios.post(
        `${BASEURL}/post/import/orders`, Data
    );
    return response;
}

export const PostCOA = async (Data) => {
    const response = await axios.post(
        `${BASEURL}/post/coa`, Data
    );
    return response
}

export const PostSales = async (Data) => {
    const response = await axios.post(
        `${BASEURL}/post/sales`, Data
    );
    return response
};

export const PostParameterMain = async (Data) => {
    const response = await axios.post(
        `${BASEURL}/post/parametermain`, Data
    );
    return response
};

export const PostCustomerAccount = async (Data) => {
    const response = await axios.post(
        `${BASEURL}/post/customer`, Data
    );
    return response;
}

export const PostOrder = async (Data) => {
    const response = await axios.post(
        `${BASEURL}/post/order`, Data
    );
    return response
}

export const PostInvoice = async (Data) => {
    const response = await axios.post(
        `${BASEURL}/post/invoice`, Data
    );
    return response;
}

export const PostAccountAdmin = async (Data) => {
    const response = await axios.post(
        `${BASEURL}/post/admin`, Data
    );
    return response;
}

export const PostNews = async (Data) => {
    const response = await axios.post(`${BASEURL}/post/news`, Data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
    return response
};

export const PostOrderEmail = async (Data) => {
    const response = await axios.post(`${BASEURL}/post/order/email`, Data);
    return response
}

export const PostAllEmailINV = async (Data) => {
    const response = await axios.post(`${BASEURL}/post/send/all/email`, Data);
    return response
}

export const PostCOASendEmail = async (Data) => {
    const response = await axios.post(`${BASEURL}/post/coa/send/email`, Data);
    return response;
}



// OLD
export const postOrder = async (Data) => {
    const response = await axios.post(`${BASEURL}/dashboard/post/orders`, Data)
    return response
}

export const postImportOrder = async (Data) => {
    const response = await axios.post(`${BASEURL}/dashboard/post/order`, Data)
    return response
}

export const UploadDocs = async (Data) => {
    const response = await axios.post(`${BASEURL}/post/uploads`, Data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
    return response
}

export const postCOA = async (Data) => {
    const response = await axios.post(`${BASEURL}/dashboard/post/coa`, Data);
    return response
}

export const postInvoice = async (Data) => {
    const response = await axios.post(`${BASEURL}/dashboard/post/invoice`, Data);
    return response
}

export const postCustomerAccount = async (Data) => {
    const response = await axios.post(`${BASEURL}/dashboard/post/customer_account`, Data);
    return response
}

export const postAccountAdmin = async (Data) => {
    const response = await axios.post(`${BASEURL}/dashboard/post/account_admin`, Data);
    return response
}

export const PostChat = async (Data) => {
    const response = await axios.post(`${BASEURL}/dashboard/post/chat`, Data);
    return response
}